import type { SVGProps } from "react";
export function MinusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        fill="currentColor"
        height={1.2}
        rx={0.6}
        width={10}
        x={3}
        y={7.4}
      />
    </svg>
  );
}
